export default __webpack_public_path__ + "static/gold-rush-logo-84a74e9f92a44289d7ef5f1e15c2fe66.png";